/* Stylesheet */

.empty_data_container {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
